<template>
  <div class="product-card">
    <div class="product-card__content">
      <div class="product-card__content-image">
        <Skeleton height="144px" width="101.33px" borderRadius="8px"></Skeleton>
      </div>
      <div class="product-card__content-product">
        <Skeleton height="32px" width="184.67px" borderRadius="6px"></Skeleton>
      <div class="skeleton-container">
           <div class="attributes">
          <div class="skeleton">
            <Skeleton height="14px" width="48px" borderRadius="4px"></Skeleton>
            <Skeleton height="14px" width="50px" borderRadius="4px"></Skeleton>
          </div>
        </div>

        <div class="attributes">
          <div class="skeleton">
            <Skeleton height="14px" width="37px" borderRadius="4px"></Skeleton>
            <Skeleton height="14px" width="60px" borderRadius="4px"></Skeleton>
          </div>
        </div>

        <div class="attributes">
          <div class="skeleton">
            <Skeleton height="14px" width="30px" borderRadius="4px"></Skeleton>
            <Skeleton height="14px" width="40px" borderRadius="4px"></Skeleton>
          </div>
        </div>
      </div>
     

        <div class="comission">
          <Skeleton height="14px" width="56px" borderRadius="4px"></Skeleton>
          <div class="skeleton">
            <Skeleton height="14px" width="38px" borderRadius="4px"></Skeleton>
          </div>
        </div>
      </div>
    </div>
    <div class="product-card__footer">
      <Skeleton height="40px" width="294px" borderRadius="6px"></Skeleton>
    </div>
  </div>
</template>

<script>
import Skeleton from './Skeleton.vue';

export default {
  name: "ProductCardSkeleton",
  components: { Skeleton },
  computed: {},
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/variables.scss";

.product-card {
  width: 318px;
  height: 220px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  border-radius: 8px;
  border: 0.5px solid $colorD20;
  background: $colorN00;

  &__content {
    width: 100%;
    gap: 8px;
    display: flex;

    &-image {
      width: 101px;
      min-width: 101px;
      min-height: 144px;
      display: flex;
      overflow: hidden;
      border-radius: 8px;
      justify-content: center;

      img {
        max-width: 101px;
        max-height: 144px;
      }
    }

    &-product {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 8px;

      .title {
        margin-bottom: 24px;
        height: 48px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 12px;
        font-weight: 600;
        line-height: 16px;
        text-wrap: wrap;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        color: $colorN80;
      }

      .attributes {
        width: calc(100% - 8px);

        .attribute {
          display: flex;
          justify-content: space-between;
          text-align: right;

          span {
            font-size: 11px;
            font-weight: 400;
            line-height: 14px;
            color: $colorN80;

            &:last-child {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              width: 120px;
            }

            &.key {
              font-weight: 600;
              color: $colorD40;
            }
          }
        }
      }

      .comission {
        gap: 4px;
        display: flex;
        padding: 6px 0;
        margin-top: auto;
        justify-content: space-between;
        padding-right: 8px;
        border-top: 0.5px solid $colorD20;
        margin-top: -18px;

        span {
          color: $colorD40;
          font-size: 11px;
          font-weight: 600;
          line-height: 14px;

          &:last-child {
            gap: 2px;
            display: flex;
            font-weight: 400;
            color: $colorN80;
          }
        }
      }
    }
  }

  &__footer {
    width: 100%;
    margin-top: auto;

    &__btn {
      font-size: 14px !important;
    }
  }
}

.skeleton {
  display: flex;
  justify-content: space-between;
}

.skeleton-container {
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  align-items: stretch;
  gap: 4px;
}
</style>